import { getPrincipalId } from "../api/metadata";

export const getEnvironment = () => {
  return window.pu_environment;
};

export const isAlpha = () => {
  return window.GameEnvironment.config.webgl_environment_name === "Dev";
};

export const isBeta = () => {
  return window.GameEnvironment.config.webgl_environment_name === "Beta";
}

export const isAmazonian = () => {
  return window.pu_environment?.public_provider_name === "AmazonFederate";
};

export const setPrincipalIdToPuEnv = async (token: string) => {
  const principal_id = await getPrincipalId(token);

  addPropertiesToPuEnv({
    principal_id: principal_id,
  });
};

export const addPropertiesToPuEnv = (properties: object) => {
  window.pu_environment = {
    ...window.pu_environment,
    ...properties,
  };
};

export const setQueryStringsEnv = (queryStrings?: Record<string, string>) => {
  if (queryStrings) {
    addPropertiesToPuEnv({ query_args: queryStrings });
  }
};
